// extracted by mini-css-extract-plugin
export default {"control":"Controler_control__5PRTy"};